import WebApp from '@twa-dev/sdk';
import type { QueryClient } from '@tanstack/react-query';
import { almatyToday, type ChargedVia, type ProfileResponse } from '@masha/shared';

const STORAGE_KEY = 'turbo-cap-notice-day';

export const TURBO_CAP_NOTICE = 'Безлимит на сегодня исчерпан, дальше списываются кредиты';

/** Turbo is on but this action was paid with credits: tell once per Almaty day. */
export function shouldShowTurboCapNotice(
  chargedVia: ChargedVia,
  turboUntil: string | null,
  now: Date = new Date(),
): boolean {
  if (chargedVia !== 'credits' || !turboUntil) return false;
  if (new Date(turboUntil).getTime() <= now.getTime()) return false;
  const today = almatyToday(now);
  try {
    if (localStorage.getItem(STORAGE_KEY) === today) return false;
    localStorage.setItem(STORAGE_KEY, today);
  } catch {
    // Storage blocked (private mode, preview): showing the notice again is harmless.
  }
  return true;
}

/** Call from a generate/rewrite onSuccess, before the ['profile'] refetch lands. */
export function notifyTurboCap(qc: QueryClient, chargedVia: ChargedVia): void {
  const turboUntil = qc.getQueryData<ProfileResponse>(['profile'])?.user.turboUntil ?? null;
  if (shouldShowTurboCapNotice(chargedVia, turboUntil)) WebApp.showAlert(TURBO_CAP_NOTICE);
}
